import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import Widget from "2g-widget";
import { useRouterProvider } from "2g-router";

import { REZERVACE as PATH_REZERVACE } from "b2b/constants/paths";
import { STAV } from "b2b/constants/zadosti";
import ZadostiGroups from "b2b/components/zadosti-groups";
import getNextWeekDates from "b2b/utils/date/getNextWeekDates";

import useMessages from "./i18n/useMessages";

function ZadostiOdbaveniWidget() {
  const history = useHistory();
  const { messageEmpty, widgetLabel } = useMessages();
  const obdobi = { ...getNextWeekDates() };
  const { getLangPath } = useRouterProvider();
  const redirectToRezervace = useCallback(
    zdroj => {
      history.push({
        pathname: getLangPath(PATH_REZERVACE.ODBAVENI),
        state: zdroj
      });
    },
    [getLangPath]
  );
  return (
    <Widget collapsable={false} title={widgetLabel()}>
      <ZadostiGroups
        messageEmpty={messageEmpty()}
        datumDo={obdobi.datumDo}
        datumOd={obdobi.datumOd}
        onChange={redirectToRezervace}
        stav={STAV.PRIJATY}
      />
    </Widget>
  );
}

export default React.memo(ZadostiOdbaveniWidget);
